import React from 'react'
import styled from 'styled-components'
import { AuthContext } from 'contexts'

import { useAppModeContext } from 'context/AppModeContext'
import { accountTypeEnum } from 'types/account'
import SubnetHome from './SubnetHome'
import ValidatorHome from './ValidatorHome'

const Home = () => {
    const { user } = React.useContext(AuthContext)

    const { selected_account } = useAppModeContext()

    const subnetMode = selected_account?.account_type === accountTypeEnum.Subnet_api
    const validatorMode = selected_account?.account_type === accountTypeEnum.Validation

    return (
        <>
            {user && (
                <StyledWrapper>
                    {subnetMode && <SubnetHome />}
                    {validatorMode && <ValidatorHome />}
                </StyledWrapper>
            )}
        </>
    )
}

export default Home

const StyledWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 100px;

    padding-bottom: 30px;
`
export const StyledMainHeaderWrapper = styled.div`
    display: flex;
    width: 100%;
    justify-content: center;
    flex-direction: column;
    align-items: center;
`
